export const TABS = ['Próximas', 'Calendario', 'Pasadas', 'Favoritas'];

interface TabCounts {
  upcoming?: number;
  past?: number;
  attended?: number;
  favorites?: number;
}

export const Tabs = ({ 
  active, 
  onChange, 
  counts 
}: { 
  active: string; 
  onChange: (tab: string) => void;
  counts?: TabCounts;
}) => {
  const getTabLabel = (tab: string) => {
    switch (tab) {
      case 'Próximas':
        return counts?.upcoming !== undefined ? `${tab} (${counts.upcoming})` : tab;
      case 'Pasadas':
        if (counts?.past !== undefined && counts?.attended !== undefined) {
          return `${tab} (${counts.attended}/${counts.past})`;
        }
        return counts?.past !== undefined ? `${tab} (${counts.past})` : tab;
      case 'Favoritas':
        return counts?.favorites !== undefined ? `${tab} (${counts.favorites})` : tab;
      default:
        return tab;
    }
  };

  return (
    <div className="flex bg-white">
      {TABS.map(tab => (
        <button
          key={tab}
          onClick={() => onChange(tab)}
          className={`flex-1 py-2 text-center border-b-2 cursor-pointer whitespace-nowrap leading-tight text-xs sm:text-sm md:text-base ${active === tab ? 'border-black font-semibold' : 'text-gray-500 border-gray-300'}`}
        >
          {getTabLabel(tab)}
        </button>
      ))}
    </div>
  );
};
